module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "toast"
    }
  }, [_c('div', {
    staticClass: "toast"
  }, [_c('div', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("知道了")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-651e72ce!./~/vue-loader/lib/selector.js?type=template&index=0!./src/comps/toast.vue
// module id = 859
// module chunks = 34